{
    "page_title__customers": "Kunden",
    "page_sub_title__customers": "Hier findest du, welche deiner Kunden als Nächstes einen Termin brauchen. Du siehst die Kunden, für die du zuständig bist, mit Zahlen und Status wie in deiner Warenwirtschaft. Die Schnellansichten oben sind fertige Listen dafür.",
    "quick_filters__customers_my_plus_customers": "🚀 Größtes Ausbaupotenzial",
    "quick_filters__customers_my_minus_customers": "⚠️ Stärkste Abwanderungen",
    "filter_menu_title__sales_rep": "Vertreter",
    "filter_menu_title__city": "Stadt",
    "filter_menu_title__zip_code": "PLZ",
    "filter_menu_title__industry": "Branche",
    "filter_menu_title__insights": "Vertriebsempfehlungen",
    "filter_menu_title__status": "Status",
    "filter_menu_title__company": "Verkaufsstandort",
    "filter_menu_title__customer_class": "Kundenart",
    "filter_menu_title__sales_region": "Vertriebsregion",
    "filter_menu_title__customer": "Kunde",
    "customer_search_placeholder": "Suche nach Name, Kundennr., PLZ, Ort",
    "table_header__name": "Kunde",
    "table_header__ttm_current": "Umsatz 12 Monate",
    "table_header__order_sum_ttm_current": "Auftragseingang 12 Monate",
    "table_header__ttm_delta": "Abweichung 12 Monate",
    "table_header__revenue_ytd": "Umsatz Laufendes Jahr",
    "table_header__order_sum_ytd": "Auftragseingang Laufendes Jahr",
    "table_header__revenue_ytd_delta": "Abweichung Vorjahr",
    "table_header__last_order_date": "Letzter Auftrag",
    "table_header__primary_rep": "Vertreter",
    "table_header__city": "Stadt",
    "table_header__industry": "Branche",
    "table_header__status": "Status",
    "table_header__expansion_potential": "Ausbaupotenzial",
    "table_header__revenue_decline": "Abwanderungen",
    "table_header__gm_ttm": "DB 12 Monate",
    "table_header__gm_ttm_percent": "DB % 12 Monate",
    "table_header__gm_ttm_delta": "Abweichung DB 12 Monate",
    "table_header__gm_ytd": "DB Laufendes Jahr",
    "table_header__gm_ytd_percent": "DB % Laufendes Jahr",
    "table_header__gm_ytd_delta": "Abweichung DB Laufendes Jahr",
    "status_new": "Neu",
    "status_active": "Aktiv",
    "status_at_risk": "Gefährdet",
    "status_inactive": "Inaktiv",
    "status_blocked": "Gesperrt",
    "status_dormant": "Ruhend",
    "status_tooltip": "Plato hilft dir, Kunden zu priorisieren. Die ersten vier Status leitet Plato aus Bestellverhalten und Risikosignalen ab:",
    "status_tooltip_new": "hat gerade erst angefangen zu bestellen",
    "status_tooltip_active": "bestellt regelmäßig",
    "status_tooltip_at_risk": "zeigt Abwanderungstendenzen",
    "status_tooltip_dormant": "keine Bestellungen in 6+ Monaten",
    "status_tooltip_inactive": "in Plato als inaktiv markiert, in Plato rückgängig machbar. Keine Empfehlungen",
    "status_tooltip_blocked": "im ERP gesperrt, nur im ERP änderbar. Keine Empfehlungen",
    "table_footer__sum": "Summe",
    "table_header__visit_count": "Dokumentierte Besuche",
    "table_header__visits_per_100k": "Besuche / 100 T€",
    "visits_per_100k_tooltip": "Anzahl der Besuche pro 100.000 € Umsatz über die letzten 12 Monate. Zeigt, ob der Besuchsaufwand zur Kundengröße passt – hilfreich, um kleine Kunden mit vielen Besuchen und zu selten besuchte große Kunden zu erkennen. Als „nicht angetroffen“ erfasste Besuche zählen nicht. Wird nur bei Kunden mit mindestens 1.000 € Umsatz berechnet.",
    "table_header__last_visit": "Letzter Besuch",
    "last_visit_tooltip": "Datum des letzten Besuchs bei diesem Kunden.",
    "leads__create_action": "Neuer Lead",
    "leads__create_submit": "Lead anlegen",
    "leads__create_success": "Lead „{{name}}“ angelegt",
    "leads__create_error": "Der Lead konnte nicht angelegt werden",
    "leads__field_name": "Firma",
    "leads__field_street": "Straße",
    "leads__field_zip_code": "PLZ",
    "leads__field_city": "Ort",
    "leads__create_hint_label": "Hinweis:",
    "leads__create_hint": "Für Leads, die noch nicht im ERP sind. Der Kunde wird als Lead in Plato angelegt, ohne Umsatz und ohne Übertragung ins ERP."
}
